<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: {
    graph: {
      type: Object,
      default: () => ({ labels: [], datasets: [] })
    }
  },
  watch: {
    graph: {
      deep: true,
      handler() {
        this.updateChart()
      }
    }
  },
  mounted() {
    this.updateChart()
  },
  methods: {
    updateChart() {
      if (!this.graph || !this.graph.labels || !this.graph.labels.length) {
        return
      }
      this.renderChart(this.graph, {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 62,
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            boxWidth: 10,
            padding: 14,
            fontColor: document.body.classList.contains('dark-mode') ? '#cbd5e1' : '#475569',
            fontSize: 11
          }
        },
        tooltips: {
          callbacks: {
            label(tooltipItem, data) {
              const ds = data.datasets[tooltipItem.datasetIndex]
              const val = ds.data[tooltipItem.index]
              const label = data.labels[tooltipItem.index] || ''
              return `${label}: ${val}`
            }
          }
        }
      })
    }
  }
}
</script>
